import React from 'react';

import Button from '../../Button/Button';

export interface VerificationButtonsProps {
  isVerifyDisabled: boolean;
  isLoading: boolean;
}

const VerificationButtons: React.FC<VerificationButtonsProps> = ({
  isVerifyDisabled,
  isLoading
}) => (
  <div className="flex justify-center">
    <Button
      type="submit"
      disabled={isVerifyDisabled}
      isLoading={isLoading}
      className="w-[334px]"
    >
      Verify
    </Button>
  </div>
);

export default VerificationButtons;
